import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css'
import { Box, TextField } from '@mui/material'
import { DateRangePicker, createStaticRanges } from 'react-date-range'
import { useEffect, useRef, useState } from 'react'

const CalendarPick = ({ inputHeight = '10px', inputWidth = '100%', callback, dataInicio = false, dataFim = false, newSxModal = {} }) => {
    const [showCalendar, setShowCalendar] = useState(false)

    const [date, setDate] = useState({
        startDate: dataInicio ? new Date(dataInicio) : new Date(),
        endDate: dataFim ? new Date(dataFim) : new Date(),
        key: 'selection'
    })

    const calendarRef = useRef(null)

    const chamaCallback = () => {
        const retornoData = {
            startDate: formatDateToBackend(date.startDate),
            endDate: formatDateToBackend(date.endDate)
        }
        callback(retornoData)
    }

    useEffect(() => {
        if (showCalendar === false) {
            chamaCallback()
        }
    }, [showCalendar])

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (calendarRef.current && !calendarRef.current.contains(event.target)) {
                setShowCalendar(false)
            }
        }

        document.addEventListener('mousedown', handleClickOutside)

        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [])

    const formatDateForDisplay = (date) => {
        const day = date.getDate()
        const month = date.getMonth() + 1
        const year = date.getFullYear()
        return `${day < 10 ? '0' + day : day}/${month < 10 ? '0' + month : month}/${year}`
    }

    const formatDateToBackend = (date) => {
        const day = date.getDate()
        const month = date.getMonth() + 1
        const year = date.getFullYear()
        return `${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}`
    }

    const handleChange = (item) => {
        setDate(item.selection)
    }

    return (
        <>
            <TextField
                onClick={() => setShowCalendar(!showCalendar)}
                value={`${formatDateForDisplay(date.startDate)} - ${formatDateForDisplay(date.endDate)}`}
                variant='outlined'
                fullWidth
                size='small'
                sx={{
                    cursor: 'pointer',
                    backgroundColor: '#FFFFFF',
                    borderRadius: '7px',
                    "& .MuiOutlinedInput-root": { "& > fieldset": { border: "none" } }
                }}
                inputProps={{
                    readOnly: true,
                    style: { height: inputHeight, width: inputWidth, fontFamily: 'Poppins', fontWeight: 400, cursor: 'pointer' }
                }} ></TextField>
            { showCalendar &&
                <Box ref={calendarRef} mt={2} sx={
                    {
                        ...{
                            position: 'absolute',
                            zIndex: 999,
                            borderRadius: '7px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.25)'
                        },
                        ...newSxModal
                    }
                }>
                    <DateRangePicker
                        ranges={[date]}
                        onChange={(item) => handleChange(item)}
                        staticRanges={createStaticRanges(staticsLabels)}
                        rangeColors={['#7C51F9']}
                        inputRanges={[]}
                    />
                </Box>
            }
        </>
    )
}

export default CalendarPick

const staticsLabels = [
    {
        label: 'Hoje',
        range: () => ({
            startDate: new Date(),
            endDate: new Date()
        })

    },
    {
        label: 'Ontem',
        range: () => ({
            startDate: new Date(new Date().setDate(new Date().getDate() - 1)),
            endDate: new Date(new Date().setDate(new Date().getDate() - 1))
        })
    },
    {
        label: 'Últimos 7 dias',
        range: () => ({
            startDate: new Date(new Date().setDate(new Date().getDate() - 7)),
            endDate: new Date()
        })
    },
    {
        label: 'Últimos 30 dias',
        range: () => ({
            startDate: new Date(new Date().setDate(new Date().getDate() - 30)),
            endDate: new Date()
        })
    },
    {
        label: 'Este mês',
        range: () => ({
            startDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
            endDate: new Date()
        })
    },
    {
        label: 'Último mês',
        range: () => ({
            startDate: new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1),
            endDate: new Date(new Date().getFullYear(), new Date().getMonth(), 0)
        })
    }
]
